import React from 'react';
import { ShowMoreButtonWrapper } from './styled';
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowRight
} from 'react-icons/md';

const ShowMoreButton = ({ visibleGroups, index, toggle }) => {
  return (
    <ShowMoreButtonWrapper
      onClick={() => toggle(index)}
      className="btn btn-link"
    >
      {visibleGroups[index] ? (
        <MdOutlineKeyboardArrowDown style={{ width: '1rem', height: '1rem' }} />
      ) : (
        <MdOutlineKeyboardArrowRight
          style={{ width: '1rem', height: '1rem' }}
        />
      )}
      {visibleGroups[index] ? 'Ocultar' : 'Mostrar mais'}
    </ShowMoreButtonWrapper>
  );
};

export default ShowMoreButton;
